/**
 * 目标用户卡片组件
 */

import React from 'react';
import { Card, Form, Row, Col, Input, Space, Button } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface TargetUserCardProps {
    painPoints: string[];
    onAddPainPoint: () => void;
    onRemovePainPoint: (index: number) => void;
    onUpdatePainPoint: (index: number, value: string) => void;
}

export const TargetUserCard: React.FC<TargetUserCardProps> = ({
    painPoints,
    onAddPainPoint,
    onRemovePainPoint,
    onUpdatePainPoint,
}) => {
    return (
        <Card title="👥 目标用户" bordered={false}>
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'target_audience']}
                        label="用户画像"
                    >
                        <TextArea
                            rows={3}
                            placeholder="描述目标用户的年龄、性别、职业、收入水平等..."
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="用户痛点">
                        <Space direction="vertical" style={{ width: '100%' }}>
                            {painPoints.map((point, index) => (
                                <Space key={index} style={{ width: '100%' }}>
                                    <Input
                                        value={point}
                                        onChange={(e) => onUpdatePainPoint(index, e.target.value)}
                                        placeholder="输入一个用户痛点"
                                        style={{ width: 500 }}
                                    />
                                    {painPoints.length > 1 && (
                                        <Button
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => onRemovePainPoint(index)}
                                        />
                                    )}
                                </Space>
                            ))}
                            <Button
                                type="dashed"
                                icon={<PlusOutlined />}
                                onClick={onAddPainPoint}
                            >
                                添加痛点
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default TargetUserCard;
